import { TrackJSErrorPayload } from 'trackjs';

export function trackjsErrorHandler(
  payload: TrackJSErrorPayload,
  error?: Error
) {
  const excludedUrls = ['/security/authenticate', '/security/verify'];

  return !excludedUrls.some((url) => error?.message.includes(url) ?? false);
}
